import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

// modules (angular)
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule as MatTableModule } from '@angular/material/table';

// modules

// components
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { QuotationRoutingModule } from './quotation-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import { QuotationDetailsComponent } from './quotation-details.component';
import { QuotationMessageComponent } from './components/message-information/quotation-messages.component';
import { MatTabsModule as MatTabsModule } from '@angular/material/tabs';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatGridListModule } from '@angular/material/grid-list';

@NgModule({
    imports: [
        // modules (angular)
        CommonModule,
        ReactiveFormsModule,
        MatIconModule,
        MatButtonModule,
        FlexLayoutModule,
        MatTableModule,
        MatTabsModule,
        MatInputModule,
        MatGridListModule,
        // modules
        QuotationRoutingModule,
        SharedModule,
        // components
        QuotationDetailsComponent,
        QuotationMessageComponent,
    ],
    exports: [QuotationDetailsComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class QuotationDetailsModule { }
